module.exports = __webpack_public_path__ + "img/paypal-button-icon.dd7ba8cb.svg";